// src/components/auth/RoleBadge.jsx
import React from 'react';
import { ROLE_LABELS, ROLE_TIERS } from './constants';

/**
 * RoleBadge Component
 * Displays user role as a styled badge
 */
const RoleBadge = ({ role }) => {
  const label = ROLE_LABELS[role] || role;
  const tier = ROLE_TIERS[role];

  // Color based on tier
  const getColorClasses = () => {
    switch (tier) {
      case 1: // Executive
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 2: // Manager
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 3: // Staff
        return 'bg-green-100 text-green-800 border-green-200';
      case 4: // Field
        return 'bg-orange-100 text-orange-800 border-orange-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getColorClasses()}`}
    >
      {label}
    </span>
  );
};

export default RoleBadge;